import { getClient } from '@/api/api-client';
import type { CompanyOrContactRelation, ICompanyMfhRelation } from '@condo/domain';

export const assignCompanyToMFH = async ({
    companyId,
    mfhId,
    relationName,
}: {
    companyId: number;
    mfhId: number;
    relationName: CompanyOrContactRelation;
}): Promise<ICompanyMfhRelation> =>
    getClient('basecamp')
        .post(`/company-mfh`, {
            companyId,
            mfhId,
            relationName,
        })
        .then(res => res.data.companyMFHRelation);
